import { fabric } from 'fabric';
import { CustomFabricObject } from '../../../global-types/canvas';
import { setAngle } from '../../../utils';

interface ResetRotationResult {
  originalAngle: number;
}

/**
 * Temporarily resets image and crop rect to 0° for crop math.
 * Counter-rotates the crop rect around the image center so the
 * spatial relationship is preserved in the unrotated frame.
 *
 * This should be called with canvas rendering suppressed so the
 * user never sees the intermediate state.
 */
export const resetRotationForCrop = (
  currentImage: CustomFabricObject,
  croppingArea: fabric.Rect,
): ResetRotationResult => {
  const originalAngle = currentImage.angle || 0;

  if (originalAngle !== 0) {
    const imageCenter = currentImage.getCenterPoint();
    const radians = fabric.util.degreesToRadians(-originalAngle);

    // Counter-rotate crop rect around image center to match the 0° frame
    const cropPoint = new fabric.Point(croppingArea.left as number, croppingArea.top as number);
    const rotatedCropPoint = fabric.util.rotatePoint(cropPoint, imageCenter, radians);
    croppingArea
      .set({
        left: rotatedCropPoint.x,
        top: rotatedCropPoint.y,
        angle: (croppingArea.angle || 0) - originalAngle,
      })
      .setCoords();

    // Reset image to 0° — all downstream math assumes this
    setAngle(currentImage, 0);
  }

  return { originalAngle };
};
